import {useGetOfferDetailApplicationQuery} from "../../offer/api/get_offer_detail";
import {useGetPropertyDetailApplicationQuery} from "../../property/api/get_property_detail";
import {useGetVendorDetailApplicationQuery} from "../../vendor/api/get_vendor_detail_application_api";
import {useLeadRequiredParams} from "./use_lead_required_params";

interface IMainLeadIds {
    vendorId: number | null;
    offerId: number | null;
    propertyId: number | null;
}

/** True once the main lead stores these ids and the details `useSendMainLead` sends with them are no longer loading */
export const useIsMainLeadSendDataReady = (ids: IMainLeadIds): boolean => {
    const storedIds = useLeadRequiredParams();

    const {isLoading: isVendorLoading} = useGetVendorDetailApplicationQuery(ids.vendorId as number, {skip: !ids.vendorId});
    const {isLoading: isOfferLoading} = useGetOfferDetailApplicationQuery(ids.offerId as number, {skip: !ids.offerId});
    const {isLoading: isPropertyLoading} = useGetPropertyDetailApplicationQuery(ids.propertyId as number, {skip: !ids.propertyId});

    const isStored =
        ids.vendorId !== null && storedIds.vendorId === ids.vendorId && storedIds.offerId === ids.offerId && storedIds.propertyId === ids.propertyId;

    return isStored && !isVendorLoading && !isOfferLoading && !isPropertyLoading;
};
import {useGetOfferDetailApplicationQuery} from "../../offer/api/get_offer_detail";
import {useGetPropertyDetailApplicationQuery} from "../../property/api/get_property_detail";
import {useGetVendorDetailApplicationQuery} from "../../vendor/api/get_vendor_detail_application_api";
import {useLeadRequiredParams} from "./use_lead_required_params";

interface IMainLeadIds {
    vendorId: number | null;
    offerId: number | null;
    propertyId: number | null;
}

/** True once the main lead stores these ids and the details `useSendMainLead` sends with them are no longer loading */
export const useIsMainLeadSendDataReady = (ids: IMainLeadIds): boolean => {
    const storedIds = useLeadRequiredParams();

    const {isLoading: isVendorLoading} = useGetVendorDetailApplicationQuery(ids.vendorId as number, {skip: !ids.vendorId});
    const {isLoading: isOfferLoading} = useGetOfferDetailApplicationQuery(ids.offerId as number, {skip: !ids.offerId});
    const {isLoading: isPropertyLoading} = useGetPropertyDetailApplicationQuery(ids.propertyId as number, {skip: !ids.propertyId});

    const isStored =
        ids.vendorId !== null && storedIds.vendorId === ids.vendorId && storedIds.offerId === ids.offerId && storedIds.propertyId === ids.propertyId;

    return isStored && !isVendorLoading && !isOfferLoading && !isPropertyLoading;
};
